import { EmptyView, emptyViewVariants } from '@components'

import { Flex } from '@billy/design-system'
import Cookies from 'js-cookie'
import { ReactElement, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { DemoInvoiceTryCard } from '@features/demoInvoice/elements/DemoInvoiceTryCard'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { InvoicesListEmptyImage } from '../../../../../../assets/images'
import { CookieKeys } from '../../../../../../enums/cookieKeys'
import { useSegment } from '../../../../../../hooks'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

export const InvoicesListEmpty = (): ReactElement => {
  const navigate = useNavigate()
  const location = useLocation()
  const { track } = useSegment()

  const { buttonText, description, title } = emptyViewVariants.externalInvoicesAndEInvoices

  const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)
  const { url: invoicesNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  const handleCreateInvoiceClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Create new invoice clicked', {
      isEmptyInvoicesList: true,
    })
    Cookies.set(CookieKeys.InvoicingInvoicesListQuery, location.search)

    if (invoicesNewUrl) {
      navigate(invoicesNewUrl)
    }
  }, [invoicesNewUrl, location.search, navigate, track])

  return (
    <>
      <EmptyView
        buttonSize="md"
        descriptionColor="discreet"
        illustration={<InvoicesListEmptyImage />}
        onClick={handleCreateInvoiceClick}
        showCTA
        tButton={buttonText}
        tDescription={description}
        tTitle={title}
      />
      <Flex justifyContent="center">
        <DemoInvoiceTryCard />
      </Flex>
    </>
  )
}
